import { AnyAction } from 'redux';
import { DP_NAME_SUCCESS } from '../types/onBoarding';
import { LOGOUT_SUCCESS } from '../types/auth';
import { DPNameType } from '../types/api-types';

export type DPNameListState = {
  dpNameList: DPNameType[];
};

export const initialState: DPNameListState = {
  dpNameList: [],
};

export default function dpNameListReducer(
  state: DPNameListState = initialState,
  action: AnyAction
): DPNameListState {
  switch (action.type) {
    case DP_NAME_SUCCESS: {
      if (Array.isArray(action.body)) {
        return { ...state, dpNameList: action.body as DPNameType[] };
      }
      const broker = action.body as DPNameType;
      if (!broker || broker.id == null) {
        return state;
      }
      const exists = state.dpNameList.some((item) => Number(item.id) === Number(broker.id));
      const dpNameList = exists
        ? state.dpNameList.map((item) =>
            Number(item.id) === Number(broker.id) ? { ...item, ...broker } : item
          )
        : [...state.dpNameList, broker];
      return { ...state, dpNameList };
    }
    case LOGOUT_SUCCESS:
      return { ...initialState };
    default:
      return state;
  }
}
